const sizeConfigs = {
  sidebar: {
    width: "260px",
  },
};

export default sizeConfigs;
